












import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "Alert"
})
export default class Alert extends Vue {
  @Prop({ default: "" }) readonly title!: string;
  @Prop({ default: true }) readonly showIcon!: boolean;

  get icon() {
    let icon = "";
    switch (this.$attrs["variant"]) {
      case "danger":
        icon = "exclamation-circle-fill";
        break;
      case "success":
        icon = "check-circle-fill";
        break;
      case "info":
        icon = "info-circle-fill";
        break;
      default:
        icon = "";
        break;
    }
    return icon;
  }
}
